import CustomEnvelope from '@public/icons/envelope_new.svg';
import React, { SVGProps } from 'react';

type CustomEnvelopeWrapperProps = SVGProps<SVGSVGElement>;
const CustomEnvelopeWrapper: React.FC<CustomEnvelopeWrapperProps> = (props) => {
  return <CustomEnvelope {...props} />;
};

export default CustomEnvelopeWrapper;
